<div class="auth-shell">
  <div class="auth-shell__content">
    <div class="auth-shell__brand">
      <img
        [src]="logoLight"
        alt="Logo"
        class="auth-shell__logo theme-logo theme-logo--light"
      />
      <img
        [src]="logoDark"
        alt=""
        class="auth-shell__logo theme-logo theme-logo--dark"
        aria-hidden="true"
      />
    </div>
    <div class="auth-shell__body">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
